export default function PrivacyPolicy() {
  return (
    <div className="container-vv py-20 max-w-4xl" data-testid="privacy-page">
      <div className="eyebrow">Privacy Policy</div>
      <h1 className="mt-3 font-display font-medium text-4xl sm:text-5xl text-[#292522]">Privacy Policy</h1>
      <div className="mt-6 rounded-2xl bg-[#FFF1E8] p-6 text-sm text-[#292522]/80">
        <strong>CONTENUTO PLACEHOLDER — DA SOTTOPORRE A VERIFICA LEGALE.</strong> Questo testo va sostituito con l'informativa privacy definitiva, redatta o validata da un/a professionista in materia di trattamento dei dati personali (Reg. UE 2016/679 - GDPR).
      </div>
      <div className="mt-8 prose max-w-none text-[#292522]/85">
        <h2 className="font-display">Titolare del trattamento</h2>
        <p>Vola Vola APS · Via Galliera 2/A, 40013 Castel Maggiore (BO) · C.F. 91436320377 · Email: volavolaaps@gmail.com.</p>
        <h2 className="font-display">Dati raccolti</h2>
        <ul>
          <li>Dati anagrafici e contatto forniti per prenotazioni, iscrizioni, richieste informazioni.</li>
          <li>Dati opzionali per newsletter (solo con consenso esplicito e separato).</li>
        </ul>
        <h2 className="font-display">Finalità</h2>
        <ul>
          <li>Gestione prenotazioni ed eventi.</li>
          <li>Comunicazioni relative alle attività dell'associazione.</li>
          <li>Newsletter (solo previo consenso).</li>
        </ul>
        <h2 className="font-display">Diritti dell'interessato</h2>
        <p>Puoi richiedere accesso, rettifica, cancellazione, portabilità dei dati e opposizione al trattamento scrivendo a volavolaaps@gmail.com.</p>
        <h2 className="font-display">Conservazione</h2>
        <p>I dati sono conservati per il tempo strettamente necessario alle finalità dichiarate e poi cancellati.</p>
      </div>
    </div>
  );
}
